import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AuthService } from '../../user/services/auth.service';
import { mapTo, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SignalRBaseHub {
  protected hubConnection: HubConnection;
  /**
   * Subject which says if a connection is currently established
   */
  connectionEstablished$ = new BehaviorSubject<boolean>(false);

  constructor(
    protected logService: LoggingService,
    protected authService: AuthService,
    protected jwtHelper: JwtHelperService) 
    { }

  /**
   * Stop SignalR connection
   */
  stopSignalR() {
    if (this.hubConnection.state === HubConnectionState.Connected) {
      this.hubConnection.stop();
    }
  }

  /**
   * Start SignalR connection only if it's not disconnected
   */
  protected startConnection() {
    if (this.hubConnection.state !== HubConnectionState.Disconnected) {
      return;
    }

    this.hubConnection.start().then(
      () => {
        this.logService.info('Connection started');
        this.connectionEstablished$.next(true);
      },
      (error) => this.logService.error(error)
    );
  }

  /**
   * Register .on server events
   */
   protected registerOnServerEvents() {
   this.hubConnection.onreconnecting(() => {
      this.logService.info('signalr is trying to reconnect');
    });

    this.hubConnection.onreconnected(() => {
      this.logService.info('signalr has been reconnected');
    });

    this.hubConnection.onclose(() => {
      this.connectionEstablished$.next(false);
      this.logService.info('signalr has been closed');
      if (this.hubConnection.state === HubConnectionState.Disconnected) {
        setTimeout(() => this.startConnection(), 3000);
      }
    });
  }

  joinGroup(groupName: string) {
    return this.connectionEstablished$.pipe(
      tap(connection => {
        if (connection) {
          this.hubConnection.invoke('AddToGroup', groupName).catch((err) => this.logService.info(err));
        }
      }),
      mapTo(null));
  }

  removeFromGroup(groupName: string) {
    if (this.hubConnection.state === HubConnectionState.Connected) {
    this.hubConnection.invoke('RemoveFromGroup', groupName).catch((err) => this.logService.info(err));
    }
  }
}
